import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useHistory, useParams, useLocation } from "react-router-dom";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import Price from "./components/Price";

import Moment from "react-moment";

import "./index.css";

const PDF = () => {
  const [configuration, setConfiguration] = useState(null);
  const [baseProduct, setBaseProduct] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const { configurationId } = useParams();
  const urlSearch = useLocation().search;
  const name = new URLSearchParams(urlSearch).get("name");
  const email = new URLSearchParams(urlSearch).get("email");
  const tel = new URLSearchParams(urlSearch).get("tel");
  const quoteNo = new URLSearchParams(urlSearch).get("quoteNo");
  const currencyCode = new URLSearchParams(urlSearch).get("currencyCode");
  const exchangeRate = new URLSearchParams(urlSearch).get("exchangeRate");
  const token = new URLSearchParams(urlSearch).get("token");
  const COMPANY_DETAILS = {
    DEFAULT: {
      companyName: "Server Builds Ltd",
      addressLine1: "Parkshot House",
      addressLine2: "5 Kew Road",
      addressLine3: "Richmond",
      addressLine4: "London",
      addressLine5: "TW9 2PR",
      email: "sales@serverbuilds.co.uk",
      tel: "020 7183 3135",
      companyNumber: "1859587",
      vatRegistrationNumber: "184994987",
    },
    AED: {
      companyName: "Server Builds FZ-LLC",
      addressLine1: "Office G16, Building 15",
      addressLine2: "Dubai Internet City",
      addressLine3: "Dubai",
      addressLine4: "UAE",
      email: "sales@serverbuilds.ae",
      tel: "050 292 3958",
      taxRegistrationNumber: "104297801300003",
      licenseNumber: "103836",
    },
    EUR: {
      companyName: "Options Direct GmbH",
      addressLine1: "Friedrichstraße 155",
      addressLine2: "10117 Berlin",
      addressLine3: "Germany",
      email: "sales@serverbuilds.de",
      tel: "+44207 183 3135",
      commercialRegister: "Charlottenburg (Berlin), HRB 275591 B",
      taxRegistrationNumber: "30/462/51305",
    },
  };

  const [companyDetails, setCompanyDetails] = useState(COMPANY_DETAILS.DEFAULT);

  const priceProps = {
    currencyCode,
    exchangeRate,
    token,
  };

  useEffect(() => {
    const code =
      currencyCode && currencyCode !== "undefined"
        ? currencyCode.toUpperCase()
        : token
        ? token.toUpperCase()
        : null;
    if (!code) return;
    setCompanyDetails(COMPANY_DETAILS[code] || COMPANY_DETAILS.DEFAULT);
  }, [currencyCode, token]);

  useEffect(() => {
    getAndSetConfiguration();
  }, []);
  useEffect(() => {
    console.log("congifuration ", configuration);
    if (configuration) {
      getAndSetBaseProduct();
    }
  }, [configuration]);

  useEffect(() => {
    if (configuration && baseProduct) {
      let ttl = baseProduct.price;

      configuration.selectedProducts.forEach((selectedCategoryProducts) => {
        selectedCategoryProducts.products.forEach((product) => {
          ttl += product.price * product.qty;
        });
      });

      setTotalPrice(ttl);
    }
  }, [configuration, baseProduct]);

  let getAndSetConfiguration = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/configuration/one?_id=${configurationId}`
      );
      if (response.status === 200) {
        setConfiguration(response.data.configuration);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  let getAndSetBaseProduct = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/bc/products/${configuration.baseProduct.bcId}`
      );
      if (response.status === 200) {
        // console.log("Response base product", baseProduct);
        setBaseProduct(response.data.product);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  return (
    <page size="A4" layout="portrait">
      <div className="header text-right">
        <img src="https://cdn11.bigcommerce.com/s-xzo998w3ks/images/stencil/250x100/logo_1653404568__76420.original.png" />
      </div>
      <div className="display-block">
        <div>
          <p>
            <strong>To:</strong>
            <br />
            {name}
            <br />
            {email}
            <br />
            {tel}
            <br />
            <br />
            <b>Quote: </b> {quoteNo}
            <br />
            <b>Configuration: </b> {}{" "}
            {configuration && configuration.configurationProductBcId} /{" "}
            {configuration && configuration._id}
            <br />
            <b>Date: </b> <Moment format="DD/MM/YY" />
          </p>
        </div>
        <div>
          <p>
            {companyDetails.companyName}
            <br />
            {companyDetails.addressLine1}
            <br />
            {companyDetails.addressLine2}
            <br />
            {companyDetails.addressLine3}
            <br />
            {companyDetails.addressLine4}
            {companyDetails.addressLine5 && (
              <span>
                <br />
                {companyDetails.addressLine5}
              </span>
            )}
            <br />
            <br />
            {companyDetails.email}
            <br />
            {companyDetails.tel}
          </p>
        </div>
      </div>
      <div>
        <br />
        <h3>Your Configuration</h3>
        <br />
        <table className="quote-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th className="price">Unit Cost</th>
              <th className="qty">Qty</th>
              <th className="price">TTL Cost</th>
            </tr>
          </thead>
          <tbody>
            {baseProduct && (
              <tr>
                <td style={{ fontWeight: "bold" }}>Base</td>
                <td>{configuration.baseProductBcId}</td>
                <td>{baseProduct.name}</td>
                <td className="price">
                  <Price value={baseProduct.price} {...priceProps} />
                </td>
                <td className="qty">{1}</td>
                <td className="price">
                  <Price value={baseProduct.price} {...priceProps} />
                </td>
              </tr>
            )}
            {configuration &&
              configuration.selectedProducts.map((selectedProduct) => {
                return selectedProduct.products.map((product, index) => {
                  return (
                    <tr>
                      <td style={{ fontWeight: "bold" }}>
                        {index === 0 ? (
                          <span>{selectedProduct.categoryName}</span>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>{product.bcId}</td>
                      <td>{product.name}</td>
                      <td className="price">
                        <Price value={product.price} {...priceProps} />
                      </td>
                      <td className="qty">{product.qty}</td>
                      <td className="price">
                        <Price
                          value={product.price * product.qty}
                          {...priceProps}
                        />
                      </td>
                    </tr>
                  );
                });
              })}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td colspan="3" className="price">
                <h4 style={{ marginTop: "30px" }}>
                  Total: <Price value={totalPrice} {...priceProps} />
                </h4>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="text-center" style={{ marginTop: "60px" }}>
        <p
          className=""
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>{companyDetails.companyName}</div>
          {companyDetails.companyNumber && (
            <div>Company No. {companyDetails.companyNumber}</div>
          )}
          {companyDetails.vatRegistrationNumber && (
            <div>VAT Reg No. {companyDetails.vatRegistrationNumber}</div>
          )}
          {companyDetails.commercialRegister && (
            <div>Commercial Register: {companyDetails.commercialRegister}</div>
          )}
          {companyDetails.taxRegistrationNumber && (
            <div>
              Tax No. {companyDetails.taxRegistrationNumber}
            </div>
          )}
          {companyDetails.licenseNumber && (
            <div>License Number: {companyDetails.licenseNumber}</div>
          )}
        </p>
      </div>
    </page>
  );
};

export default PDF;
